export class AvaCrop {
  constructor() {
    return {
      restrict: "E",
      scope: {
        id: '@',
        width: '@',
        height: '@',
        pic: '@',
        action: '='
      },
      template:
        `<div class="frame">
          <div class="imageEditorLoading" id="imageEditorLoading">
            <img src="/images/ajax-loader.gif" />
          </div>
          <div>
            <img class="ava-crop-picture" ng-src="{{pic}}"/>
          </div>
        </div>`,
      replace:true,
      link: function(scope, element, attrs) {
        // Look the picture up inside this directive instead of through a global
        // #picture lookup: admin-banner-crud.html also carries an #picture node,
        // and two croppers on a page used to fight over the same element.
        let picture = element.find('img.ava-crop-picture');
        let loader = element.find('.imageEditorLoading');
        let ready = false;
        let builtPic = null; // the pic the live instance was measured from

        function destroy() {
          if (!ready) {
            return;
          }

          picture.guillotine('remove');
          ready = false;
          builtPic = null;
        }

        function build() {
          // A missing or broken src still reports `complete` and can fire
          // `load`. Guillotine would then cache a 0x0 natural size, and since
          // it ignores every later init call on the same element, the cropper
          // would stay broken for the rest of the page's life.
          if (!picture[0].naturalWidth || !picture[0].naturalHeight) {
            return;
          }

          // Guillotine caches the natural size, scale, angle and offset when it
          // is first instantiated and turns any further init into a no-op. The
          // modal keeps the same <img> around for every photo, so without
          // tearing the instance down the second photo an admin opens is
          // previewed - and cropped - using the first photo's geometry.
          destroy();

          picture.guillotine({
            width: 370,
            height: 493
          });

          ready = true;
          builtPic = scope.pic;
          picture.guillotine('fit');
        }

        scope.action = {
          isReady: function(){
            return ready;
          },

          // Reopening the editor on the photo that is already loaded fires no
          // `load` event, so callers ask for the rebuild explicitly to drop any
          // zoom/rotation left over from the previous session. A picture that
          // has not arrived yet is left to its own load event instead - building
          // now would measure whichever photo is still on screen.
          reload: function(){
            if (builtPic === scope.pic) {
              build();
            }
          },

          // Natural size of the photo the crop data refers to, so callers don't
          // have to measure the rendered <img> - which guillotine has resized.
          getSize: function(){
            return ready
              ? {width: picture[0].naturalWidth, height: picture[0].naturalHeight}
              : null;
          },

          getData: function(){
            return ready ? picture.guillotine('getData') : null;
          },

          loading: function(status){
            if(status){
              loader.show();
            } else{
              loader.hide();
            }
          },

          reset: function(){
            picture.guillotine('reset');
          },

          rotateRight: function(){
            picture.guillotine('rotateRight');
          },

          rotateLeft: function(){
            picture.guillotine('rotateLeft');
          },

          zoomIn: function(){
            picture.guillotine('zoomIn');
          },

          zoomOut: function(){
            picture.guillotine('zoomOut');
          },

          fit: function(){
            picture.guillotine('fit');
          }
        };

        // Retire the instance the moment a different picture is requested. Until
        // that picture's load event rebuilds it, getData() reports "not ready"
        // rather than handing out the previous photo's scale and offset - which
        // is what produced crops zoomed differently from the preview.
        scope.$watch('pic', (pic) => {
          if (pic !== builtPic) {
            destroy();
          }
        });

        picture.on('load', build);

        if (picture.prop('complete')) {
          build();
        }

        scope.$on('$destroy', destroy);
      }
    };
  }
}
